
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenAverageCurvePeriod {

    coverageEndDate: moment.Moment;
    coverageStartDate: moment.Moment;
    datasetKey: string;
    periodKind: string;
    periodYear: number;
    rowCount: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genAverageCurvePeriod: GenAverageCurvePeriod);

    constructor( input?: GenAverageCurvePeriod ) {
        if ( input && typeof input !== 'number' ) {
            if ( input.coverageEndDate && typeof input.coverageEndDate === 'string' ) {
                this.coverageEndDate = moment(input.coverageEndDate).utc();
            } else {
                this.coverageEndDate = input.coverageEndDate;
            }
            if ( input.coverageStartDate && typeof input.coverageStartDate === 'string' ) {
                this.coverageStartDate = moment(input.coverageStartDate).utc();
            } else {
                this.coverageStartDate = input.coverageStartDate;
            }
            this.datasetKey = input.datasetKey; // string [string]
            this.periodKind = input.periodKind; // string [string]
            this.periodYear = input.periodYear; // int [number]
            this.rowCount = input.rowCount; // int [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenAverageCurvePeriod[] {
        if (arr && arr.map) {
          return arr.map(a => new GenAverageCurvePeriod(a));
        } else {
          return [];
        }
    }
}

